import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ icon, className }) => (
  <i className={`fa fa-${icon} ${className}`} aria-hidden="true" />
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
